var MAX_PARAM_STRING_LEN = 100;
var MAX_CUSTOM_PARAMS = 20;

/**
 * Coerce event params to analytics-safe values: integers and strings only.
 * Booleans become 0/1; finite numbers are floored; other types stringify.
 * @param {Record<string, unknown>} params
 * @returns {Record<string, string | number>}
 */
export function sanitizeAnalyticsParams(params) {
  var out = {};
  if (!params || typeof params !== "object") return out;
  var keys = Object.keys(params);
  for (var i = 0; i < keys.length && i < MAX_CUSTOM_PARAMS; i++) {
    var key = keys[i];
    if (!key || key.length > 40) continue;
    var value = params[key];
    if (value == null) continue;
    if (typeof value === "string") {
      out[key] = value.length > MAX_PARAM_STRING_LEN
        ? value.slice(0, MAX_PARAM_STRING_LEN)
        : value;
    } else if (typeof value === "boolean") {
      out[key] = value ? 1 : 0;
    } else if (typeof value === "number") {
      if (!isFinite(value)) continue;
      out[key] = Math.floor(value);
    } else {
      out[key] = String(value).slice(0, MAX_PARAM_STRING_LEN);
    }
  }
  return out;
}

/**
 * @param {Record<string, string | number>} params
 * @returns {boolean}
 */
export function analyticsParamsUseOnlyStringsAndIntegers(params) {
  if (!params || typeof params !== "object") return true;
  var keys = Object.keys(params);
  for (var i = 0; i < keys.length; i++) {
    var v = params[keys[i]];
    if (typeof v === "string") continue;
    if (typeof v === "number" && Number.isInteger(v)) continue;
    return false;
  }
  return true;
}
